import React from 'react';
import ContentLoader, { Rect } from 'react-content-loader';

const ContentHolder = ({ 
  loading, 
  primaryColor, 
  secondaryColor, 
  speed, 
  height, 
  rows, 
  children 
}) => {
    if (loading) {
      const ht = height || ((rows || 10) * 7);
      return (
        <ContentLoader 
          height={ht} 
          speed={speed || 1} 
          primaryColor={primaryColor} 
          secondaryColor={secondaryColor}
        >          
          {Array(rows || 10).fill().map((_, i) => {
            const y = (i + 1) * 7;
            return (
              <Rect 
                key={`placeholder-rect-${i}`} 
                x={0} 
                y={y} 
                height={3} 
                radius={0} 
                width={400} 
              />
            );
          })} 
        </ContentLoader>
      );
    }
    return children ? children : null;
};

export default ContentHolder;
